export default "__VITE_ASSET__CN3_VKbQ__"